import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function AddBlogCategory() {
    const [catName, setCatName] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            catName: catName,
        };
        try {
            const res = await HomeService.addBlogCategory(data);
            if (res?.status) {
                toast.success("Blog category added successfully!");
                clearAddForm();
                navigate("/manage-blog-category");
            }
        } catch (error) {
            toast.error("Failed to add Blog category.");
            console.error("Error adding Blog category:", error);
        }
    };

    const clearAddForm = () => {
        setCatName("");
    };

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid">

                <div className="mt-5">
                    <div style={headLineStyle} className="page-headline">
                        Add Blog Category
                    </div>
                    <hr />

                    <section className="chartBox_area">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="catName">
                                        Category Name<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="catName"
                                        className="form-control"
                                        value={catName}
                                        onChange={(e) => setCatName(e.target.value)}
                                        placeholder="Enter Property Type"
                                        required
                                    />
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="btn mt-3"
                                style={{
                                    background:'rgb(133, 218, 79)',
                                    borderRadius:'13px'
                                }}
                            >
                            
                                Add Blog Category
                            </button>
                        </form>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default AddBlogCategory;
